import * as React from 'react';
import {useDispatch} from 'react-redux';

import {openComposerWithId} from '../../../../../../ui/email/email-composer-actions';

import {Link} from '../../link/link';

// should probably not be in shells but here it is for now

type Props = {
    value: string | null | undefined;
    entityId: string | null | undefined;
    isHidden?: boolean;
};

export function Email(props: Props) {
    const dispatch = useDispatch();

    const handleClick = (entityId: string, value: string): void => {
        if (NutClientConfig.sendFromNutshellEnabled) {
            dispatch(openComposerWithId(entityId));
        } else {
            window.open(`mailto:${value}?bcc=bcc@nutshell.com`);
        }
    };

    return props.value && props.entityId ? (
        <div title={props.isHidden ? undefined : props.value}>
            <Link
                variant='primary'
                size='small'
                onClick={(e) => {
                    if (props.entityId && props.value) {
                        const entityId = props.entityId;
                        const value = props.value;

                        e.stopPropagation();
                        handleClick(entityId, value);
                    }
                }}
            >
                {props.value}
            </Link>
        </div>
    ) : null;
}
